import React, {PropTypes} from 'react';
import LeadAccountPanelItem from './lead-account-panel-item';

const LeadAccountPanelCollection = props =>
    <ul className='lead-account-panel-collection'>
        {props.leadAccounts.map((leadAccount, index) =>
            <LeadAccountPanelItem
                isSelected={leadAccount.leadAccount.account === props.selectedLeadAccount}
                key={index}
                leadAccount={leadAccount}
                onLeadAccountChange={props.onLeadAccountChange}
            />
        )}
    </ul>;

LeadAccountPanelCollection.displayName = 'LeadAccountPanelCollection';
LeadAccountPanelCollection.propTypes = {
    leadAccounts: PropTypes.array.isRequired,
    onLeadAccountChange: PropTypes.func.isRequired,
    selectedLeadAccount: PropTypes.string.isRequired
};

export default LeadAccountPanelCollection;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-aside/lead-account-panel-collection.js